import { createFileRoute } from '@tanstack/react-router';
import { QualidadeView } from '@/modules/agentes/components/AgentesGestao';

// Pilar Qualidade & evals do módulo Agentes (gestão) — admin-only.
export const Route = createFileRoute('/_authed/agentes_/qualidade')({
  component: QualidadeView,
});
